import {
    Box,
    Button,
    Flex,
    FormControl,
    FormLabel,
    Grid,
    Input,
    InputGroup,
    InputRightAddon,
    Text
} from "@chakra-ui/react";
import {ChevronDownIcon, ChevronUpIcon} from "@chakra-ui/icons";
import React, {useState} from "react";
import DesignData from "../../../resources/DesignTab/design_data.json";

const InputSection = ({field, handleFieldChange}) => (
    <FormControl mt={4}>
        <FormLabel>{field.label} {field.inputType === "number" && `(${field.units})`}</FormLabel>
        <InputGroup>
            <Input type={field.inputType} value={field.value} onChange={(e) => handleFieldChange(field, e.target.value)} />
            {field.inputType === "number" &&   <InputRightAddon children={field.units} />}
        </InputGroup>
    </FormControl>
);

const NestedInputSection = ({parentField, handleFieldChange}) => (
    <Box>
        <Text fontSize={"lg"} fontWeight={"bold"}>{parentField.label}</Text>
        <Flex gap={4}>
            {
                parentField.items.map(field => (
                    <FormControl mt={4}>
                        <FormLabel>{field.label} {field.inputType === "number" && `(${field.units})`}</FormLabel>
                        <InputGroup>
                            <Input type={field.inputType} value={field.value} onChange={(e) => handleFieldChange(parentField, e.target.value, field)} />
                            {field.inputType === "number" &&   <InputRightAddon children={field.units} />}
                        </InputGroup>
                    </FormControl>
                ))
            }
        </Flex>
    </Box>
);

const OtherSection = ({label, fields, setFields}) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    }

    const handleFieldChange = (inputField, value, inputItem=null) => {
        if (inputItem !== null) {
            const modifiedFields = fields.map(field => {
                if (field.label === inputField.label) {
                    const modifiedItems = field.items.map(item => item.label === inputItem.label ? {...item, value: value} : {...item});
                    return {...field, items: modifiedItems};
                } else
                    return {...field};
            });
            setFields(modifiedFields);
        } else {
            const modifiedFields = fields.map(field => field.label === inputField.label ? {...field, value: value} : {...field});
            setFields(modifiedFields);
        }
    }

    return (
        <Box px={4} mb={4} py={4} borderWidth={"2px"} borderRadius={"md"}>
            <Flex justify="space-between" align="center" cursor={"pointer"}>
                <Text userSelect={"none"} fontSize={"xl"} fontWeight={"bold"}>{label}</Text>
                <Box>
                    <Button onClick={toggleCollapse}>
                        {isCollapsed ? <ChevronDownIcon/> : <ChevronUpIcon/>}
                    </Button>
                </Box>
            </Flex>
            {!isCollapsed && (
                <Flex direction={"column"} gap={4} mt={2}>
                    {fields.map((field, index) => {
                        if (field.hasOwnProperty("items")) {
                            return <NestedInputSection key={index} parentField={field} handleFieldChange={handleFieldChange}/>
                        } else {
                            return <InputSection key={index} field={field} handleFieldChange={handleFieldChange}/>
                        }
                    })}
                </Flex>
            )}
        </Box>
    );
}

export default OtherSection;